export default __webpack_public_path__ + "static/media/zapier-logo.0af4fa1e.svg";